module.exports = __webpack_public_path__ + "img/coupon-bg.74e24431.png";